import React from 'react';
import { Link } from 'react-router-dom';

const Menu = ({ isOpen, onClose, onLogout, userEmail, userName }) => {
  // SADECE BU MAİLLER DENETİM PANELİNİ GÖREBİLİR (Kendi mailin veya eklemek istediklerin)
  const ADMIN_EMAILS = ['dundardilmen2@gmail.com', 'admin@atesgozcusu.com'];
  const isAdmin = ADMIN_EMAILS.includes(userEmail);

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-[9997] transition-opacity" onClick={onClose}></div>
      )}

      <div className={`fixed top-0 right-0 h-full w-72 bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-[9998] ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="p-8 flex flex-col h-full font-sans antialiased overflow-y-auto">
          
          <div className="flex justify-between items-center mb-8">
            <h2 className="text-2xl font-black text-slate-800 tracking-tighter uppercase">Menü</h2>
            <button onClick={onClose} className="text-slate-400 hover:text-red-600 transition-colors">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
          </div>

          <div className="mb-6 pb-6 border-b border-slate-100">
            <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest mb-2">Aktif Kullanıcı</p>
            <p className="text-sm font-bold text-slate-700 truncate bg-slate-50 p-3 rounded-xl border border-slate-100 capitalize">
              {userName || userEmail || 'Telefon Kullanıcısı'}
            </p>
          </div>

          <nav className="flex-grow flex flex-col gap-2">
            <Link to="/" onClick={onClose} className="flex items-center gap-3 text-slate-600 hover:text-red-600 hover:bg-red-50 p-4 rounded-2xl font-bold transition-all">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" /></svg>
              Canlı Harita
            </Link>
            
            <Link to="/profilim" onClick={onClose} className="flex items-center gap-3 text-slate-600 hover:text-blue-600 hover:bg-blue-50 p-4 rounded-2xl font-bold transition-all">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
              Profilim
            </Link>

            <Link to="/ihbarlarim" onClick={onClose} className="flex items-center gap-3 text-slate-600 hover:text-amber-600 hover:bg-amber-50 p-4 rounded-2xl font-bold transition-all">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
              İhbarlarım
            </Link>

            <Link to="/bilgi" onClick={onClose} className="flex items-center gap-3 text-slate-600 hover:text-emerald-600 hover:bg-emerald-50 p-4 rounded-2xl font-bold transition-all">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              Yararlı Bilgiler
            </Link>
            
            {/* SADECE ADMİN GÖREBİLİR */}
            {isAdmin && (
              <Link to="/admin" onClick={onClose} className="flex items-center gap-3 text-slate-600 hover:text-slate-900 hover:bg-slate-100 p-4 rounded-2xl font-bold transition-all">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
                Denetim Paneli
              </Link>
            )}
          </nav>

          <button onClick={onLogout} className="mt-8 flex items-center justify-center gap-2 bg-slate-800 text-white py-4 rounded-2xl font-bold hover:bg-black shadow-[0_5px_0_#0f172a] active:shadow-none active:translate-y-[5px] transition-all">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
            Güvenli Çıkış
          </button>
        </div>
      </div>
    </>
  );
};

export default Menu;